export enum AccountFeatureFlag {
    AI_ATTRIBUTION = 'ai_attribution',
    BIGCOMMERCE_SELFSERVICE_UX = 'bigcommerce-selfservice-ux',
    CLASSIFIER_INFO = 'classifier_info',
    DATA_ENRICHMENT = 'data_enrichment',
    DATA_ENRICHMENT_ANALYTICS = 'data_enrichment_analytics',
    DATABASE_ALERTS = 'database_alerts',
    EDRTS_REAL_TIME_EXPORT_TRIGGERS = 'edrts_real_time_export_triggers',
    EXPORT_TYPE_SELECTION = 'export_type_selection',
    FEATURE_FEEDAI_CATEGORIZATION_GENAI = 'feedai_categorization_genai',
    GOOGLE_UCP_BETA = 'google_ucp_beta',
    FEATURE_FEEDAI_SYNC_CATEGORIZATION = 'feedai_sync_categorization',
    INSECURE_FTP_SUPPORT = 'insecure_ftp_support',
    LIA_RAAP_READINESS_CHECK = 'lia_raap_readiness_check',
    REMOTE_FILE_UPDATE_TRIGGER = 'remote_file_update_trigger',
    RUN_ATTRIBUTION = 'run_attribution',
    RUN_CLASSIFY = 'run_classify',
    TRANSFORMED_DATA_OVERRIDES = 'transformed_data_overrides',
    WORKSPACE_OPTOUT = 'workspace_optout',
    FEATURE_META_AUTH = 'meta_auth',
    FEATURE_MICROSOFT_AUTH = 'microsoft_auth',
    SKU_LEVEL_FAILURE_ALERTING = 'sku_level_failure_alerting'
}

export enum BigCommerceSelfServiceFeatureFlag {
    FREE = 'free',
    PAID = 'paid',
    NONE = 'none'
}
